import React, { createContext, useContext, useMemo } from 'react';
import { APP_STORE_URL, DEFAULT_LAUNCH_STATE, GOOGLE_PLAY_URL, LaunchState } from '../data/launch';
type LaunchContextValue = {
  launchState: LaunchState;
  isPublicLaunch: boolean;
  appStoreUrl: string;
  googlePlayUrl: string;
};
const LaunchContext = createContext<LaunchContextValue>({
  launchState: DEFAULT_LAUNCH_STATE,
  isPublicLaunch: DEFAULT_LAUNCH_STATE === 'public-launch',
  appStoreUrl: APP_STORE_URL,
  googlePlayUrl: GOOGLE_PLAY_URL
});
export function LaunchProvider({
  launchState,
  children
}: {
  launchState: LaunchState;
  children: React.ReactNode;
}) {
  const value = useMemo<LaunchContextValue>(() => ({
    launchState,
    isPublicLaunch: launchState === 'public-launch',
    appStoreUrl: APP_STORE_URL,
    googlePlayUrl: GOOGLE_PLAY_URL
  }), [launchState]);
  return <LaunchContext.Provider value={value} data-id="element-360" data-mp="2d9hpsdgotkp0">{children}</LaunchContext.Provider>;
}
export function useLaunch() {
  return useContext(LaunchContext);
}